<template>
	<div class="cta" @click="showCta()" v-html="label"></div>
</template>

<script>

//import FlecheIcon from './icons/fleche-droite.svg';

import texts from '@texts/controls.json'

export default {
	name: 'Cta',
	data() {
		return {
			label: texts.ctaButton,
		}
	},
	methods: {
		showCta() {
			this.$emit('click')
		}
	}
}
</script>


<style scoped lang="scss">
.cta {
	@extend %base-btn;
	@extend %font-cta-big;

	width: 3.5rem;
	height: 3.5rem;
	background-color: $jaune;
	text-align: center;
	padding: 52px;
	border-radius: 50%;
	display: flex;




}

</style>
